import {
  SET_TITLE,
  SET_ONCONFIRM,
} from './types';

const mutations = {
  [SET_TITLE](state, title) {
    state.title = title;
  },
  [SET_ONCONFIRM](state, func) {
    state.onConfirm = func;
  }
};

export default mutations;
